import React from 'react'
import { connect } from 'react-redux'
import accounting from 'accounting'
import Modal from 'react-responsive-modal'
import Pagination from 'react-js-pagination'
import moment from 'moment'
import TransferHistoryActions from '../../Redux/TransferHistoryRedux'
import MatchPaymentForm from '../../Containers/Order/MatchPaymentForm'
import MatchManualForm from '../../Containers/Order/MatchManualForm'
import DownloadAutoTransferList from '../../Containers/Order/DownloadAutoTransferList'
import DateTime from 'react-datetime'
import includes from 'lodash/includes'
import isObject from 'lodash/isObject'
import { setTimeout } from 'core-js'

class AutoTransferList extends React.Component {
  constructor (props) {
    super(props)
    this.dateFormat = 'DD MMM YYYY, h:mm:ss a'
    this.processStatus = [
      { value: 'auto-confirm', label: 'AUTO CONFIRM' },
      { value: 'manual-confirm', label: 'MANUAL CONFIRM' },
      { value: 'manual-match', label: 'MANUAL MATCH' },
      { value: 'null', label: 'PENDING' }
    ]
    this.state = {
      showModal: null,
      selected: '',
      sort: 'seq_yes',
      filter: {
        page: 1,
        from: null,
        until: null,
        limit: 10,
        status: '',
        order_number: '',
        bank_name: '',
        amount: ''
      }
    }
  }

  componentDidMount = () => {
    this._fetchData()
  }

  _toggleModal = (modalId = null) => {
    this.setState({ showModal: modalId })
  }

  _select = (item = {}, action = null) => {
    this._toggleModal(action)
    this.setState({
      selected: item
    })
  }

  _sort = () => {
    if (this.state.sort === 'seq_yes') {
      this.setState({ sort: 'seq_no' })
    } else {
      this.setState({ sort: 'seq_yes' })
    }
    setTimeout(() => { this._fetchData() }, 250)
  }

  _fetchData = (filter = { ...this.state.filter }, event) => {
    let params = {
      ...this.state.filter,
      ...filter
    }

    if (this.state.filter.from && this.state.filter.until) {
      params.from = this.state.filter.from.format('Y-MM-DD')
      params.until = this.state.filter.until.format('Y-MM-DD')
    } else {
      params.from = null
      params.until = null
    }

    if (this.state.sort !== 'seq_yes') {
      params.sort = this.state.sort
    }

    if (event) event.preventDefault()
    this.props.getTransferHistory(params)
  }

  _changePage = (page) => {
    let filter = {...this.state.filter, page}
    this.setState({ filter })
    this._fetchData(filter)
  }

  _filterChange = (event, field) => {
    const uniq = ['page', 'filterDate', 'from', 'until', 'order_status']
    let val = null
    if (includes(uniq, field)) {
      if (field === 'from' || field === 'until') {
        if (isObject(event)) {
          val = event
        }
      } else {
        val = event
      }
    } else {
      val = event.target.value
    }
    let filter = {...this.state.filter}
    filter[field] = val
    this.setState({ filter })
  }

  render () {
    const { transfer_history } = this.props

    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>
              Auto Transfer List
              {(transfer_history.fetching || transfer_history.processing) &&
                <div className='badge badge-info ml-2'>{transfer_history.fetching ? 'Loading' : 'Processing'} ...</div>
              }
            </h3>
            {
              (this.props.auth.user && this.props.auth.user.role !== 'cs') &&
              <button className='btn btn-primary' onClick={() => this._toggleModal('download-list')}>Download List</button>
            }
          </div>
          <div className='title-block'>
            <p className='title-description'>Filter:</p>
            <form className='form-inline' onSubmit={(event) => this._fetchData({}, event)}>
              <div className='form-group mr-2 mb-3'>
                <label className='form-group mr-2'>Order Number: </label>
                <input style={{width: '250px'}} type='text' placeholder='Order Number' className='form-control' value={this.state.filter.order_number} onChange={(event) => this._filterChange(event, 'order_number')} />
              </div>
              <div className='form-group mr-2 mb-3'>
                <label className='form-group mr-2'>Customer Bank Name: </label>
                <input style={{width: '250px'}} type='text' placeholder='Customer Bank Name' className='form-control' value={this.state.filter.bank_name} onChange={(event) => this._filterChange(event, 'bank_name')} />
              </div>
              <div className='form-group mr-2 mb-3'>
                <label className='form-group mr-2'>Amount: </label>
                <input style={{width: '250px'}} type='number' placeholder='Amount' className='form-control' value={this.state.filter.amount} onChange={(event) => this._filterChange(event, 'amount')} />
              </div>
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Date Range:</label>
                <DateTime
                  value={this.state.filter.from}
                  closeOnSelect
                  onChange={(date) => this._filterChange(date, 'from')}
                  dateFormat='DD/MM/YYYY'
                  timeFormat={false}
                />
              </div>
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>To:</label>
                <DateTime
                  value={this.state.filter.until}
                  closeOnSelect
                  onChange={(date) => this._filterChange(date, 'until')}
                  dateFormat='DD/MM/YYYY'
                  timeFormat={false}
                />
              </div>
              <div className='form-group mr-2 mb-3'>
                <label className='control-label mr-2'>Process Status</label>
                <select className='form-control' value={this.state.filter.status} onChange={(event) => this._filterChange(event, 'status')} >
                  <option value=''>-Process Status-</option>
                  {this.processStatus.map((list, i) => (
                    <option key={i} value={list.value}>{list.label}</option>
                  ))}
                </select>
              </div>
              <div className='form-group mr-2 mb-2'>
                <button type='submit' className='btn btn-primary'>Apply Filter</button>
              </div>
            </form>
          </div>
        </header>
        <section className='section' style={{ width: '150%' }}>
          <div className='card'>
            {!(transfer_history.fetching || transfer_history.processing) && transfer_history.err &&
              <div className='alert alert-danger'>{transfer_history.err}</div>
            }
            <div className='card-block'>
              <table className='table table-hover table-striped'>
                <thead>
                  <tr>
                    {
                      (this.props.auth.user && this.props.auth.user.role !== 'cs') &&
                      <th className='text-center'>Action</th>
                    }
                    <th role='button' onClick={() => this._sort()}>
                      Seq
                      <span className='badge badge-info'>
                        <i className={`fa fa-${this.state.sort === 'seq_yes' ? 'sort-amount-down' : 'sort-amount-up'}`} />
                      </span>
                    </th>
                    <th>Retrieve Date</th>
                    <th>Order Number</th>
                    <th>Process Status</th>
                    <th>Transfer Amount</th>
                    <th>DB/CR</th>
                    {
                      (this.props.auth.user && this.props.auth.user.role !== 'cs') &&
                      <th>End Balance</th>
                    }
                    <th>Customer Bank Name</th>
                    <th>Transfer Note</th>
                  </tr>
                </thead>
                <tbody>
                  { !transfer_history.data || !transfer_history.data.data.length
                    ? <tr>
                      <td colSpan='10' className='text-center'>- NO DATA -</td>
                    </tr>
                    : transfer_history.data.data.map((item, i) => (
                      <tr key={i}>
                        {
                            (this.props.auth.user && this.props.auth.user.role !== 'cs') &&
                            <td className='text-center'>
                              {
                                (!item.order_id && item.account_name !== 'IONPAY NETWORKS PT' && item.process_status !== 'manual-confirm')
                                ? <div className='d-flex justify-content-around'>
                                  <button className='btn btn-primary mr-1' onClick={() => this._select(item, 'payment')}>Payment</button>
                                  <button className='btn btn-primary' onClick={() => this._select(item, 'manual')}>Manual</button>
                                </div>
                                : '-----------'
                              }
                            </td>
                          }
                        <td>{ item.seq_no }</td>
                        <td>{ moment.unix(item.retrieve_date).format(this.dateFormat) }</td>
                        <td>{ item.order && item.order.order_number ? item.order.order_number : (item.order_id ? item.order_id : '-') }</td>
                        <td className='text-center' >{ item.process_status || 'PENDING' }</td>
                        <td className='text-right'>
                          { accounting.formatMoney(item.amount, { format: '%v', thousand: ',', decimal: '.', precision: 2 }) }
                        </td>
                        <td>{ item.debit_credit }</td>
                        {
                        (this.props.auth.user && this.props.auth.user.role !== 'cs') &&

                          <td className='text-right'>
                            { accounting.formatMoney(item.end_balance, { format: '%v', thousand: ',', decimal: '.', precision: 2 }) }
                          </td>
                        }
                        <td>{ item.account_name || '-' }</td>
                        <td>{ item.note || '-' }</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* PAYMENT */}
        <Modal open={this.state.showModal === 'payment'} onClose={this._toggleModal} closeOnOverlayClick>
          <MatchPaymentForm detail={this.state.selected} closeModal={() => this._toggleModal()} />
        </Modal>

        {/* MANUAL */}
        <Modal open={this.state.showModal === 'manual'} onClose={this._toggleModal} closeOnOverlayClick>
          <MatchManualForm detail={this.state.selected} closeModal={() => this._toggleModal()} />
        </Modal>

        {/* Download Auto Transfer List */}
        <Modal open={this.state.showModal === 'download-list'} onClose={this._toggleModal} closeOnOverlayClick>
          <DownloadAutoTransferList closeModal={() => this._toggleModal()} />
        </Modal>

        <section className='text-center'>
          {(transfer_history.data && transfer_history.data.total > 10) &&
            <Pagination
              innerClass='pagination'
              itemClass='page-item'
              linkClass='page-link'
              activePage={transfer_history.data.page || this.state.filter.page}
              itemsCountPerPage={this.state.filter.limit}
              totalItemsCount={transfer_history.data.total}
              pageRangeDisplayed={5}
              onChange={this._changePage}
            />
          }
        </section>

      </div>
    )
  }
}

const stateToProps = (state) => ({
  transfer_history: state.transfer_history,
  auth: state.auth
})

const dispatchToProps = (dispatch) => ({
  getTransferHistory: (filter) => dispatch(TransferHistoryActions.transferHistoryRequest(filter))
})

export default connect(stateToProps, dispatchToProps)(AutoTransferList)



// WEBPACK FOOTER //
// ./src/Pages/Order/AutoTransferList.js